import APIClient from '@/shared/http/clients/api.js'

const resourceName = 'REComprovanteRendimento'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/comprovante/cliente/${id}`, data, config)
const DownloadComprovante = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/comprovante/download/cliente/${id}`, data, config)
const incomereport = {
  GetAll,
  DownloadComprovante
}

export default incomereport



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/incomereport.js